import React, { useState, useEffect, useContext } from "react";
import Plan, { IPlan } from "../../services/api/Plan";
import Year, { IYear } from "../../services/api/Year";
import Month, { IMonth } from "../../services/api/Month";
import Select from "../../components/Form/Select";
import GroupList from "./components/GroupList";
import ContentHeader from "../../components/ContentHeader";
import { ReactComponent as PlanLogo } from "../../components/ContentHeader/assets/images/plan.svg";
import Loading from "../../components/Loading";
import AuthContext from "../../contexts/AuthContext";


const PlanUpdate: React.FC = () => {
  const { user } = useContext(AuthContext);
  const [plan, setPlan] = useState<IPlan[]>([]);
  const [years, setYears] = useState<IYear[]>([]);
  const [months, setMonths] = useState<IMonth[]>([]);
  const [loading, isLoading] = useState<Boolean>(true);

  const [year, setYear] = useState<number>(0);
  const [month, setMonth] = useState<number>(0);

  const date = new Date();
  // Se o mês for janeiro (0), ajusta para dezembro do ano anterior
  if (date.getMonth() === 0) {
    date.setFullYear(date.getFullYear() - 1);  // Ajusta o ano para o anterior
    date.setMonth(11);  // Define o mês como dezembro (11)
  } else {
    date.setMonth(date.getMonth() - 1);  // Subtrai 1 do mês, caso não seja janeiro
  }

  async function LoadPlan(year: number, month: number) {
    try {
      const response: IPlan[] = await Plan.GetAll(year, month);
      setPlan(response);
    } catch (error) {
    }
  }

  useEffect(() => {
    Promise.all([Year.GetAll(), Month.GetAll()])
      .then((value) => {

        const years = value[0].filter((value) => { return value.active });
        setYears(years);
        setMonths(value[1]);

				setYear(date.getFullYear());
        setMonth(date.getMonth() + 1);

        LoadPlan(years[0].name, date.getMonth() + 1);
        isLoading(false);
      })
      .catch(() => undefined);
  }, []);

  useEffect(() => {
    if (!loading) LoadPlan(year, month);
  }, [year, month]);

  function list(obj: any): any {
    return { value: obj.id, label: obj.name };
  }

  return (
    <main className="wrapperApp">
      <ContentHeader
        title="Plan Update"
        Icon={PlanLogo}
        breadcrumb={["Plan Update"]}
      />
      <div id="content">
        <section className="content__block">
          {loading ? (
            <Loading />
          ) : (
            <>
              <div className="content__header">
                <h2 className="content__title">INSERT OR EDIT UNIT DATA</h2>

                <div className="multi-selects">
                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="month"
                      title="Month"
                      disabled={user!.profile.name === "Sender"}
                      options={months.map(list)}
                      value={month}
                      handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                        setMonth(+event.currentTarget.value);
                      }}
                    />
                  </div>

                  <div className="content__select">
                    <Select
                      className="select-custom select-custom--medium select-custom--shadow"
                      name="year"
                      title="Year"
                      disabled={user!.profile.name === "Sender"}
                      options={years.map((obj) => { return { value: obj.name, label: obj.name } })}
                      value={year}
                      handleChange={(event: React.FormEvent<HTMLSelectElement>) => {
                        setYear(+event.currentTarget.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="groups edit__buttons">
                <GroupList data={plan} year={year} month={month} />
              </div>
            </>
          )}
        </section>
      </div>
    </main>
  );
};

export default PlanUpdate;
